import { ComponentPropsWithoutRef } from 'react'

import { ContentfulText } from '../../../common/ContentfulText'
import { useEntryField } from '../Article.hooks'

type BaseProps = {
	fieldPath?: string
	fallbackfieldPath?: string
}

type Props = BaseProps & Omit<ComponentPropsWithoutRef<typeof ContentfulText>, 'field'>

export function ArticleText({ fieldPath, fallbackfieldPath, ...rest }: Props) {
	const primaryField = useEntryField({ fieldPath })
	const fallbackField = useEntryField({ fieldPath: fallbackfieldPath })

	if ('error' in primaryField) {
		return <ContentfulText {...rest} field={fallbackField} />
	}

	return (
		<div className="w-full text-2xl text-center [&>h2]:max-md:text-xl">
			<ContentfulText {...rest} field={primaryField} />
		</div>
	)
}
